import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

import LogInModal from 'flarum/common/components/LogInModal';

export default class LessonPlanDirectoryListItem extends Component {
  createLogInModal() {
    return LogInModal;
  }
  view(vnode) {
    const { lesson_plan } = this.attrs;

    // const attributes = {
    //   lesson_plan,
    //   className: `UserCard--directory${useSmallCards ? ' UserCard--small' : ''}`,
    //   controlsButtonClassName: 'Button Button--icon Button--flat',
    // };

    // const url = app.route('lesson_plan', { id: lesson_plan.id() });

    // let img;
    // if (lesson_plan.thumbnail()) {
    //   img = '<img src="' + app.forum.attribute('baseUrl') + '/' + this.lesson_plan.thumbnail() + '" alt="' + lesson_plan.title() + '">';
    // } else {
    //   img = '<i class="fas fa-book" style="font-size: 13rem; padding: 1rem; color: #ccc;"></i>';
    // }

    return (
      // <a href="" class="card">
      <Link
        className=""
        href={app.route.lesson_plan(lesson_plan.id())}
        onclick={(e) => {
          if (!app.session.user) {
            e.preventDefault();
            app.modal.show(this.createLogInModal());
          }
        }}
        target="_blank"
      >
        <div class="card-header">
          {lesson_plan.thumbnail()
            ? m('img', { src: app.forum.attribute('baseUrl') + '/' + lesson_plan.thumbnail(), alt: lesson_plan.title(), class: 'card__image' })
            : m('div', { class: 'empty-box' }, m('div', lesson_plan.title()))}
        </div>
        <div class="card__overlay card-body">
          <div>
            <span className={`tag tag-${app.translator.trans('td-lesson-plans.lib.agegroup_classes.' + lesson_plan.age_group())}`}>
              {app.translator.trans('td-lesson-plans.lib.agegroup.' + lesson_plan.age_group())}
            </span>
            <div className={`tag-2 my-1`}>{lesson_plan.activity_type() ? lesson_plan.activity_type().title : ''}</div>
            <h3>{lesson_plan.title()}</h3>
          </div>
          <div className={`tag-2 my-1`}>{lesson_plan.developmental_area() ? lesson_plan.developmental_area().title : ''}</div>
        </div>
      </Link>
    );

    /* return (
      <div className="wrap">
        <Link
          className="link"
          href={app.route.lesson_plan(lesson_plan.id())}
          onclick={(e) => {
            if (!app.session.user) {
              e.preventDefault();
              app.modal.show(this.createLogInModal());
            }
          }}
        >
          <div class="img-info-wrap">
            <div class="img-wrap">
              {lesson_plan.thumbnail()
                ? m('img', { src: app.forum.attribute('baseUrl') + '/' + lesson_plan.thumbnail(), alt: lesson_plan.title() })
                : m('i', { class: 'fas fa-book', style: 'font-size: 13rem; padding: 1rem; color: #ccc;' })}
            </div>
            <div class="info">
              <div class="title">
                <span>{lesson_plan.title()}</span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    ); */
  }
}
